import {SET_APP_NAME, SET_APP_MODULE, SET_APP_MENU, SET_APP_CONTENT, SET_NAV_MENUS, SET_APP_LINK} from "../../constants"

const RoleAll = ["super", "admin", "client", "agent"];
const RoleSuper = ["super"];
const RoleAdmin = ["super", "admin"];
const RoleAgent = ["super", "admin", "agent"];

const getStorage = (key) => {
    let val = localStorage.getItem(key);
    if (typeof val === "undefined") {
        return "";
    }
    if (val === null) {
        return ""
    }
    return val;
}
const setStorage = (key, val) => {
    localStorage.setItem(key, val);
    console.log("localStorage > ", localStorage)
    return val;
}
const initial = {
    CurrentApp: localStorage.getItem("@nomad-app") || setStorage("@nomad-app", "nomad"),
    CurrentModule: getStorage("@nomad-module") || setStorage("@nomad-module", "home"),
    CurrentMenu: getStorage("@nomad-menu") || setStorage("@nomad-menu", "Overview"),
    CurrentLink: getStorage("@nomad-link") || setStorage("@nomad-link", "home-overview-index"),
    CurrentSubmenu: getStorage("@nomad-submenu") || setStorage("@nomad-submenu", ""),
    AllRole: RoleAll,
    menus: {
        home: {
            Overview: [
                {
                    app: "nomad",
                    name: "Overview",
                    link: "home-overview-index",
                    roles: RoleAgent,
                    isDefault: true
                },
            ]
        },
        "workspace": {
            Forms: [

                {
                    app: "nomad",
                    name: "Incident",
                    link: "workboard-database-new-case",
                    roles: RoleAgent,
                    isDefault: true
                },
                /*{
                    app: "nomad",
                    name: "Incident 2",
                    link: "workboard-database-new-case1",
                    roles: RoleAgent,
                    isDefault: true
                },*/
                {
                    app: "nomad",
                    name: "Callback Request",
                    link: "workboard-database-lead",
                    roles: RoleAgent,
                    isDefault: true
                },
            ],
            "View & Actions": [

                {
                    app: "nomad",
                    name: "Incident",
                    link: "workboard-view-case",
                    roles: RoleAgent,
                    isDefault: false
                },
                {
                    app: "nomad",
                    name: "Special",
                    link: "workboard-view-emergency",
                    roles: RoleAgent,
                    isDefault: true
                },
                {
                    app: "nomad",
                    name: "Reminder",
                    link: "workboard-view-reminder",
                    roles: RoleAgent,
                    isDefault: false
                },
                {
                    app: "nomad",
                    name: "Entities",
                    link: "workboard-view-entities",
                    roles: RoleAgent,
                    isDefault: false
                },

            ],
            Report: [

                {
                    app: "nomad",
                    name: "Date Range",
                    link: "workboard-database-new-case",
                    roles: RoleAgent,
                    isDefault: true
                }, {
                    app: "nomad",
                    name: "CDR",
                    link: "workboard-report-cdr",
                    roles: RoleAgent,
                    isDefault: true
                },
            ],
            Callcenter: [

                {
                    app: "nomad",
                    name: "Outbound",
                    link: "workboard-callcenter-outbound",
                    roles: RoleAgent,
                    isDefault: true
                },
                {
                    app: "nomad",
                    name: "CDR",
                    link: "workboard-report-cdr",
                    roles: RoleAdmin,
                    isDefault: true
                },
                {
                    app: "nomad",
                    name: "Live Call",
                    link: "workboard-callcenter-live-call",
                    roles: RoleAdmin,
                    isDefault: true
                },
                {
                    app: "nomad",
                    name: "Queue Status",
                    link: "workboard-callcenter-queue-status",
                    roles: RoleAdmin,
                    isDefault: true
                },
            ],
            Export: [
                {
                    app: "nomad",
                    name: "Incident",
                    link: "setting-export-date-range",
                    roles: RoleAdmin,
                    isDefault: true
                },
                {
                    app: "nomad",
                    name: "Inbound Call State",
                    link: "setting-inbound-call-state",
                    roles: RoleAdmin,
                    isDefault: true
                },
            ],
        },
        settings: {
            Projects: [
                {
                    app: "nomad",
                    name: "Create Project",
                    link: "setting-database-project",
                    roles: RoleSuper,
                    isDefault: true
                },
                {
                    app: "nomad",
                    name: "Form Structure",
                    link: "setting-database-attribute",
                    roles: RoleAdmin,
                    isDefault: true
                },{
                    app: "nomad",
                    name: "Form Structure 2",
                    link: "setting-database-attribute2",
                    roles: RoleAdmin,
                    isDefault: true
                },
            ],
            Activities: [
                {
                    app: "nomad",
                    name: "Create Activity",
                    link: "setting-activity-create",
                    roles: RoleAdmin,
                    isDefault: true
                },
                {
                    app: "nomad",
                    name: "Fields Structure",
                    link: "setting-activity-structure",
                    roles: RoleAdmin,
                    isDefault: true
                },
            ],
            Stages: [
                {
                    app: "nomad",
                    name: "Create Stage",
                    link: "setting-stage-create",
                    roles: RoleAdmin,
                    isDefault: true
                },
                {
                    app: "nomad",
                    name: "Fields Structure",
                    link: "setting-stage-structure",
                    roles: RoleAdmin,
                    isDefault: true
                },
            ],
            Entities: [
                {
                    app: "nomad",
                    name: "Create Entity",
                    link: "setting-entity-create",
                    roles: RoleAdmin,
                    isDefault: true
                },
                {
                    app: "nomad",
                    name: "Fields Structure",
                    link: "setting-entity-structure",
                    roles: RoleAdmin,
                    isDefault: true
                },
                {
                    app: "nomad",
                    name: "Records",
                    link: "setting-entity-record",
                    roles: RoleAdmin,
                    isDefault: true
                },
            ],

            Report: [
                {
                    app: "nomad",
                    name: "Define Phone Field",
                    link: "setting-report-define-phone",
                    roles: RoleAdmin,
                    isDefault: true
                },{
                    app: "nomad",
                    name: "Define Email Field",
                    link: "setting-report-define-email",
                    roles: RoleAdmin,
                    isDefault: true
                },{
                    app: "nomad",
                    name: "Special Report",
                    link: "setting-report-view-incident",
                    roles: RoleAdmin,
                    isDefault: true
                },
            ],


            Util: [
                {
                    app: "nomad",
                    name: "Incident Category",
                    link: "setting-util-category",
                    roles: RoleAdmin,
                    isDefault: true
                },
                {
                    app: "nomad",
                    name: "Incident Status",
                    link: "setting-util-status",
                    roles: RoleAdmin,
                    isDefault: true
                },
                {
                    app: "nomad",
                    name: "Incident Priority",
                    link: "setting-util-priority",
                    roles: RoleAdmin,
                    isDefault: true
                },
            ],
            User: [
                {
                    app: "nomad",
                    name: "Manage User",
                    link: "setting-user-create",
                    roles: RoleAdmin,
                    isDefault: true
                },
            ],
            Allocation: [
                {
                    app: "nomad",
                    name: "User To Project",
                    link: "setting-allocation-user-project",
                    roles: RoleAdmin,
                    isDefault: true
                }, {
                    app: "nomad",
                    name: "User To Voip",
                    link: "setting-allocation-user-voip",
                    roles: RoleAdmin,
                    isDefault: true
                },
                {
                    app: "nomad",
                    name: "User To Queue",
                    link: "setting-allocation-user-queue",
                    roles: RoleAdmin,
                    isDefault: true
                },
                {
                    app: "nomad",
                    name: "Manage Queue",
                    link: "setting-allocation-manage-queue",
                    roles: RoleAdmin,
                    isDefault: true
                },
                {
                    app: "nomad",
                    name: "Company To CloudCall",
                    link: "setting-allocation-company-cloudcall",
                    roles: RoleAdmin,
                    isDefault: true
                },

            ],

        },

    },

}


const reduceNavigations = (state = initial, action) => {
    let newState = state;
    switch (action.type) {
        case SET_APP_NAME:
            newState.CurrentApp = action.payload;
            localStorage.setItem("@nomad-app", action.payload);
            return Object.assign({}, newState);
        case SET_APP_MODULE:
            newState.CurrentModule = action.payload;
            localStorage.setItem("@nomad-module", action.payload);
            return Object.assign({}, newState);
        case SET_APP_MENU:
            newState.CurrentMenu = action.payload;
            localStorage.setItem("@nomad-menu", action.payload);
            return Object.assign({}, newState);
        case SET_APP_CONTENT:
            newState.CurrentMenu = action.payload;
            localStorage.setItem("@nomad-content", action.payload);
            return Object.assign({}, newState);
        case SET_APP_LINK:
            newState.CurrentLink = action.payload;
            localStorage.setItem("@nomad-link", action.payload);
            return Object.assign({}, newState);
        case SET_NAV_MENUS:
            newState.menus = action.payload;
            return Object.assign({}, newState);
        default:
            return state
    }
}

export default reduceNavigations;

